<p-table
  #dt
  [value]="jobs"
  [columns]="cols"
  [rowHover]="true"
  dataKey="uuid"
  styleClass="job-list"
  [(selection)]="selectedJobs"
  [rows]="dashboardService.filters()[this.dashboardName].rows || 25"
  (onPage)="onPageChange($event)"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
  responsiveLayout="scroll"
  [paginator]="true"
  [resizableColumns]="true"
  [lazy]="true"
  columnResizeMode="fit"
  [totalRecords]="totalRecords"
  [loading]="loading"
  (onLazyLoad)="loadJobs($event)"
  [first]="first"
  [sortField]="dashboardService.filters()[this.dashboardName].sortField"
  [sortOrder]="dashboardService.filters()[this.dashboardName].sortOrder"
  (onSort)="onSort($event)"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onRowSelect)="notifyJobSelectionChange()"
  (onRowUnselect)="notifyJobSelectionChange()"
  (onHeaderCheckboxToggle)="notifyJobSelectionChange()"
  (onPage)="onPage($event)"
  scrollHeight="calc(100vh - 254px)"
>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="12">
        <div class="empty-dashboard-row-content">
          <ds-empty-state
            title="No Jobs to Display"
            description="Start by adding/moving jobs or check back later to see updates."
          ></ds-empty-state>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 20px" *ngIf="sharedDataService.data.access_level == 1">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th
        style="width: 1rem; max-width: 150px"
        pSortableColumn="client_company__name"
        pResizableColumn
      >
        <div class="flex justify-content-between align-items-center">
          Client
          <p-sortIcon field="client_company__name"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="name"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th pSortableColumn="name" pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Name
          <p-sortIcon field="name"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="name"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th pSortableColumn="assigned_to" pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Assigned To
          <p-sortIcon field="assigned_to"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="assigned_to"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Current Group
        </div>
      </th>
      <th pSortableColumn="target_start_date" pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Start Date
          <p-sortIcon field="target_start_date"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="due_date"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th
        pSortableColumn="completed_date"
        pResizableColumn
        *ngIf="showCompletedDate()"
      >
        <div class="flex justify-content-between align-items-center">
          Completed Date
          <p-sortIcon field="completed_date"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="name"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th pSortableColumn="due_date" pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Due Date
          <p-sortIcon field="due_date"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="due_date"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>
      <th pSortableColumn="status" pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Status
          <p-sortIcon field="status"></p-sortIcon>
          <!-- <p-columnFilter
            type="text"
            field="status"
            display="menu"
            class="ml-auto"
          ></p-columnFilter> -->
        </div>
      </th>

      <!-- <th pResizableColumn pSortableColumn="recurring">
        <div class="flex justify-content-between align-items-center">
          Repeats
          <p-sortIcon field="status"></p-sortIcon>
        </div>
      </th> -->

      <th pResizableColumn>
        <div
          class="flex justify-content-between align-items-center"
          style="margin-left: 10px"
        >
          Tasks
        </div>
      </th>

      <th pResizableColumn>
        <div class="flex justify-content-between align-items-center">
          Client Tasks
        </div>
      </th>

      <th pSortableColumn="tags" pResizableColumn>
        <div class="flex justify-content-between align-items-center">Tags</div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-job let-columns="columns">
    <tr
      [ngClass]="{
        'selected-row-hover-effect': job.uuid == lastSelectedJob?.uuid,
      }"
      class="p-selectable-row"
      (click)="selectJob(job, $event)"
    >
      <td style="width: 20px" *ngIf="sharedDataService.data.access_level == 1">
        <p-tableCheckbox
          [value]="job"
          (click)="onCheckboxClick(job, $event)"
        ></p-tableCheckbox>
      </td>
      <td>
        <!-- <span class="p-column-title">Client</span> -->
        <div class="clip-client-name" tooltip="{{ job.client_company?.name }}">
          {{ job.client_company?.name }}
        </div>
      </td>
      <td>
        <!-- <span class="p-column-title">Name</span> -->
        {{ job?.name }}
      </td>
      <td>
        <!-- <span class="p-column-title">Assigned To</span> -->
        <div class="avatar" style="width: 32px; height: 32px">
          <img
            [src]="job.assigned_to?.pictureUrl"
            style="width: 32px; height: 32px"
          />
        </div>
        {{ job.assigned_to?.full_name }}
      </td>
      <td>
        <app-jobs-groups-due [job]="job" />
      </td>
      <td>
        <!-- <span class="p-column-title">Start Date</span> -->
        {{
          job.target_start_date
            | amParse: "MM-DD-YYYY"
            | amFromUtc
            | amDateFormat: "MMM Do, YYYY"
        }}
      </td>
      <td *ngIf="showCompletedDate()">
        <!-- <span class="p-column-title">Completed Date</span> -->
        {{
          job.completed_date
            | amParse: "MM-DD-YYYY"
            | amFromUtc
            | amDateFormat: "MMM Do, YYYY"
        }}
      </td>
      <td>
        <!-- <span class="p-column-title">Due Date</span> -->
        {{
          job.due_date
            | amParse: "MM-DD-YYYY"
            | amFromUtc
            | amDateFormat: "MMM Do, YYYY"
        }}
      </td>
      <td
        class="job-list-status"
        [ngClass]="{
          'not-started': job.status == 0,
          'in-progress': job.status == 1,
          'on-hold': job.status == 2,
          completed: job.status == 3,
        }"
      >
        <!-- <span class="p-column-title">Status</span> -->
        <div class="text text-center">
          {{
            job.status == 0
              ? "Not Started"
              : job.status == 1
                ? "In Progress"
                : job.status == 2
                  ? "On Hold"
                  : "Completed"
          }}
        </div>
      </td>
      <!-- <td>
        <span class="p-column-title">Repeats</span>
        <div class="text text-center">
          <i *ngIf="job.recurring" class="feather check"></i>
        </div>
      </td> -->
      <td>
        <!-- <span class="p-column-title">Client Tasks</span> -->
        <div class="d-flex align-items-center" *ngIf="job.tasks_count > 0">
          <div class="progress-bar">
            <div
              class="meter"
              style="width: {{
                ((job.tasks_count - job.undone_tasks_count) * 100) /
                  job.tasks_count
              }}%"
            ></div>
          </div>
          <span
            >{{ job.tasks_count - job.undone_tasks_count }}/{{
              job.tasks_count
            }}</span
          >
        </div>
      </td>
      <td>
        <!-- <span class="p-column-title">Tasks</span> -->
        <div
          class="d-flex align-items-center"
          *ngIf="job.client_tasks_count > 0"
        >
          <div class="progress-bar">
            <div
              class="meter"
              style="width: {{
                ((job.client_tasks_count - job.undone_client_tasks_count) *
                  100) /
                  job.client_tasks_count
              }}%"
            ></div>
          </div>
          <span
            >{{ job.client_tasks_count - job.undone_client_tasks_count }}/{{
              job.client_tasks_count
            }}</span
          >
        </div>
      </td>
      <td>
        <!-- <span class="p-column-title">Tags</span> -->
        <ch-tag
          *ngFor="let tag of job.tags"
          [name]="tag.name"
          [color]="tag.color"
        ></ch-tag>
      </td>
    </tr>
  </ng-template>
</p-table>
